import { gql } from "@apollo/client";

export const CREATE_MANUFACTURER_MUTATION = gql`
    mutation CreateMasterManufacturer($input: CreateMasterManufacturerInput!) {
        createMasterManufacturer(input: $input) {
            id
            name
            countryCode
            country
            website
            contactEmail
            phoneNumber
            description
            isActive
            contactPerson
            address
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

// Update Manufacturer Mutation

export const UPDATE_MANUFACTURER_MUTATION = gql`
    mutation UpdateMasterManufacturer($input: UpdateMasterManufacturerInput!) {
        updateMasterManufacturer(input: $input) {
            id
            name
            countryCode
            country
            website
            contactEmail
            phoneNumber
            description
            isActive
            contactPerson
            address
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

// Delete Manufacturer Mutation

export const DELETE_MANUFACTURER_MUTATION = gql`
    mutation DeleteMasterManufacturer($id: ID!) {
        deleteMasterManufacturer(input: { id: $id }) {
            success
            message
        }
    }
`;

// Create Vendor Mutation

export const CREATE_VENDOR_MUTATION = gql`
    mutation CreateMasterVendor($input: CreateMasterVendorInput!) {
        createMasterVendor(input: $input) {
            id
            company_name
            website
            email
            name
            phone_number
            country_code
            vendor_type
            can_login
            invited_by_user
            created_at
            updated_at
        }
    }
`;

// Update Vendor Mutation

export const UPDATE_VENDOR_MUTATION = gql`
    mutation UpdateMasterVendor($input: UpdateMasterVendorInput!) {
        updateMasterVendor(input: $input) {
            id
            company_name
            website
            email
            name
            phone_number
            country_code
            vendor_type
            can_login
            invited_by_user
            created_at
            updated_at
        }
    }
`;

// Delete Vendor Mutation

export const DELETE_VENDOR_MUTATION = gql`
    mutation DeleteMasterVendor($id: ID!) {
        deleteMasterVendor(input: { id: $id }) {
            success
            message
        }
    }
`;

// Create Product Category Mutation

export const CREATE_PRODUCT_CATEGORY_MUTATION = gql`
    mutation CreateProductCategory($input: CreateProductCategoryInput!) {
        createProductCategory(input: $input) {
            id
            parentId
            name
            description
            isActive
            iconName
            iconColor
            iconType
        }
    }
`;

// Update Product Category Mutation

export const UPDATE_PRODUCT_CATEGORY_MUTATION = gql`
    mutation UpdateProductCategory($input: UpdateProductCategoryInput!) {
        updateProductCategory(input: $input) {
            id
            parentId
            name
            description
            isActive
            iconName
            iconColor
            iconType
        }
    }
`;

// Delete Product Category Mutation

export const DELETE_PRODUCT_CATEGORY_MUTATION = gql`
    mutation DeleteProductCategory($id: ID!) {
        deleteProductCategory(input: { id: $id })
    }
`;

// Create Work Order Stage Mutation

export const CREATE_PRODUCT_TYPE_MUTATION = gql`
    mutation CreateProductType($input: CreateProductTypeInput!) {
        createProductType(input: $input) {
            id
            categoryId
            parentId
            name
            description
            fieldDefinitions
            evidenceRequirements
            isActive
            iconName
            iconType
            iconColor
            groupType
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

// Update Product Type Mutation

export const UPDATE_PRODUCT_TYPE_MUTATION = gql`
    mutation UpdateProductType($input: UpdateProductTypeInput!) {
        updateProductType(input: $input) {
            id
            categoryId
            parentId
            name
            description
            fieldDefinitions
            evidenceRequirements
            isActive
            iconName
            iconType
            iconColor
            groupType
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

// Delete Product Type Mutation

export const DELETE_PRODUCT_TYPE_MUTATION = gql`
    mutation DeleteProductType($id: ID!) {
        deleteProductType(input: { id: $id })
    }
`;

// Create Asset Part Mutation

// Update Asset Part Mutation

// Remove Asset Part Mutation
// Master Asset Part Fields



// Products Mutations

export const CREATE_PRODUCT_MUTATION = gql`
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      isActive
    }
  }
`;

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      isActive
      information
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const DELETE_PRODUCT_MUTATION = gql`
  mutation DeleteProduct($input: DeleteProductInput!) {
    deleteProduct(input: $input)
  }
`;

export const CREATE_FAQ_MUTATION = gql`
  mutation CreateMasterFAQ($input: CreateMasterFAQInput!) {
    createMasterFAQ(input: $input) {
      id
      appliesTo
      referenceId
      reference
      question
      answer
      tags
      displayOrder
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const UPDATE_FAQ_MUTATION = gql`
  mutation UpdateMasterFAQ($input: UpdateMasterFAQInput!) {
    updateMasterFAQ(input: $input) {
      id
      appliesTo
      referenceId
      reference
      question
      answer
      tags
      displayOrder
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const DELETE_FAQ_MUTATION = gql`
  mutation DeleteMasterFAQ($id: ID!) {
    deleteMasterFAQ(input: { id: $id })
  }
`;

// Product Service Types Mutations

export const CREATE_PRODUCT_SERVICE_TYPE_MUTATION = gql`
  mutation CreateProductServiceType($input: CreateProductServiceTypeInput!) {
    createProductServiceType(input: $input) {
      id
      name
      productCategoryIds
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const UPDATE_PRODUCT_SERVICE_TYPE_MUTATION = gql`
  mutation UpdateProductServiceType($input: UpdateProductServiceTypeInput!) {
    updateProductServiceType(input: $input) {
      id
      name
      productCategoryIds
      description
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const DELETE_PRODUCT_SERVICE_TYPE_MUTATION = gql`
  mutation DeleteProductServiceType($input: DeleteProductServiceTypeInput!) {
    deleteProductServiceType(input: $input)
  }
`;

// Master Document Types

export const CREATE_MASTER_DOCUMENT_TYPE_MUTATION = gql`
  mutation CreateMasterDocumentType($input: CreateMasterDocumentTypeInput!) {
    createMasterDocumentType(input: $input) {
      id
      type
      description
      prompt
    }
  }
`;

export const UPDATE_MASTER_DOCUMENT_TYPE_MUTATION = gql`
  mutation UpdateMasterDocumentType($input: UpdateMasterDocumentTypeInput!) {
    updateMasterDocumentType(input: $input) {
      id
      type
      description
      prompt
    }
  }
`;

export const DELETE_MASTER_DOCUMENT_TYPE_MUTATION = gql`
  mutation DeleteMasterDocumentType($id: ID!) {
    deleteMasterDocumentType(input: { id: $id }) {
      success
      message
    }
  }
`;

// ==================== Plan Mutations ====================

export const CREATE_PRODUCT_MAINTENANCE_SCHEDULE_MUTATION = gql`
    mutation CreateProductMaintenanceSchedule($input: CreateProductMaintenanceScheduleInput!) {
        createProductMaintenanceSchedule(input: $input) {
            id
            productId
            scheduleType
            intervalValue
            intervalUnit
            maintenanceTasks
            requiredParts
            isMandatory
            isActive
            createdAt
            updatedAt
            product {
                id
                parentId
               
            }
        }
    }
`;

// Update Product Maintenance Schedule Mutation

export const UPDATE_PRODUCT_MAINTENANCE_SCHEDULE_MUTATION = gql`
    mutation UpdateProductMaintenanceSchedule($input: UpdateProductMaintenanceScheduleInput!) {
        updateProductMaintenanceSchedule(input: $input) {
            id
            productId
            scheduleType
            intervalValue
            intervalUnit
            maintenanceTasks
            requiredParts
            isMandatory
            isActive
            createdAt
            updatedAt
        }
    }
`;

// Delete Product Maintenance Schedule Mutation

export const DELETE_PRODUCT_MAINTENANCE_SCHEDULE_MUTATION = gql`
    mutation DeleteProductMaintenanceSchedule($input: DeleteProductMaintenanceScheduleInput!) {
        deleteProductMaintenanceSchedule(input: $input)
    }
`;

// Update Master Data Request Mutation

// Delete Master Data Request Mutation

// Compliance Lens Mutations
